import React from 'react';
//import '../styles/InvestingElement.css';

const InvestingElement = ({ stock}) => {
  return (
    <div>
      <h1>{stock}</h1>
    </div>
  );
};

export default InvestingElement;